import React, { useState, useContext } from 'react';

import UserContext from 'contexts/UserContext';
import Grade from 'containers/Administrator/Users/Create_Old/Student/Grades/Grade';
import Add from 'containers/Administrator/Users/Create_Old/Student/Grades/Add';
import Icon from 'components/Icon';

const Grades = () => {
	// Use user's context
	const { user } = useContext(UserContext);

	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Toggle modal's visibility
	const handleModal = () => setModal(m => !m);

	return (
		<>
			<h2>Klases ({user.grades?.length})</h2>

			{/* Student's grades */}
			{!!user.grades?.length && <div className="studentGrades studentGrades--selected withMarginTop">
				{user.grades?.map(grade =>
					<Grade key={grade.id} grade={grade} />
				)}
			</div>}

			{/* Toggle grade selection modal */}
			<div className="addBlock withMarginTop" onClick={handleModal}>
				<Icon icon="widgets" size="lg" className="addBlock__icon" />
				<div className="addBlock__title">Pievienot klasi</div>
				<div className="addBlock__description">Piesaistiet studentam klasi</div>
			</div>

			{/* Grade selection modal */}
			<Add modal={modal} handleModal={handleModal} />
		</>
	);
};

export default Grades;